import { 
  Settings, 
  FileText, 
  CheckCircle, 
  Building2, 
  AlertCircle,
  Clock,
  Plus,
  Edit3,
  Trash2,
  Save,
  X,
  Users,
  Mail,
  Shield,
  UserPlus,
  ArrowLeft,
  Calendar,
  Filter,
  ChevronDown,
  MessageSquare,
  Database
} from 'lucide-react';

export const iconMap: Record<string, any> = {
  Settings,
  FileText,
  CheckCircle,
  Building2,
  AlertCircle,
  Clock,
  Plus,
  Edit3,
  Trash2,
  Save,
  X,
  Users,
  Mail,
  Shield,
  UserPlus,
  ArrowLeft,
  Calendar,
  Filter,
  ChevronDown,
  MessageSquare,
  Database
};

export const getIconComponent = (iconName: string) => {
  return iconMap[iconName] || Settings; // Default to Settings if icon not found
};
